// Teklif şablonu marka şeridi — orijinal marka logoları (public/brands), kullanıcı sırası.
export const QUOTE_BRANDS = [
  ["ÖZNUR KABLO", "/brands/oznur.png"],
  ["VİKO", "/brands/viko.png"],
  ["ACK", "/brands/ack.png"],
  ["CATA", "/brands/cata.png"],
  ["SIEMENS", "/brands/siemens.png"],
  ["MUTLUSAN", "/brands/mutlusan.png"],
  ["LEGRAND", "/brands/legrand.png"],
  ["TENSE", "/brands/tense.png"],
  ["ÇETİNKAYA PANO", "/brands/cetinkaya.png"],
];

let _pending = null;
const toDataUrl = (blob) => new Promise((res) => { const r = new FileReader(); r.onloadend = () => res(r.result); r.readAsDataURL(blob); });
const dims = (src) => new Promise((res, rej) => { const im = new Image(); im.onload = () => res({ w: im.naturalWidth, h: im.naturalHeight }); im.onerror = rej; im.src = src; });

export function loadBrandLogos() {
  if (!_pending) {
    _pending = Promise.all(QUOTE_BRANDS.map(async ([name, src]) => {
      try {
        const blob = await (await fetch(src)).blob();
        const data = await toDataUrl(blob);
        const { w, h } = await dims(data);
        return { name, data, w, h };
      } catch { return null; }
    }));
  }
  return _pending;
}
